<template>
  <div class="text-center py-4">
    <!-- 成功 -->
    <template v-if="result && result.success">
      <v-icon
        color="success"
        size="64"
        class="mb-3"
      >
        {{ icons.mdiCheckCircle }}
      </v-icon>

      <p class="text-h5 font-weight-bold mb-1">
        {{ result.customer.name }}
      </p>

      <p
        v-if="result.customer.member_number"
        class="text-body-2 grey--text mb-3"
      >
        会員No. {{ result.customer.member_number }}
      </p>

      <v-chip
        color="primary"
        large
        class="mb-3"
      >
        <v-icon left>
          {{ icons.mdiCounter }}
        </v-icon>
        {{ result.visit.visit_count }}回目の来店
      </v-chip>

      <p
        v-if="result.visit.last_visited_at"
        class="text-body-2 grey--text"
      >
        前回来店: {{ formatDate(result.visit.last_visited_at) }}
      </p>
      <p
        v-else
        class="text-body-2 grey--text"
      >
        初回来店
      </p>
    </template>

    <!-- クールダウン -->
    <template v-else-if="result && result.error === 'cooldown'">
      <v-icon
        color="warning"
        size="64"
        class="mb-3"
      >
        {{ icons.mdiClockAlert }}
      </v-icon>

      <p class="text-h5 font-weight-bold mb-1">
        {{ result.customer.name }}
      </p>

      <p class="text-body-1 warning--text">
        {{ result.message }}
      </p>
    </template>

    <!-- 次のスキャンへ -->
    <v-btn
      class="mt-4"
      color="primary"
      @click="$emit('back')"
    >
      <v-icon left>
        {{ icons.mdiQrcodeScan }}
      </v-icon>
      次のチェックイン
    </v-btn>

    <!-- 自動で戻る -->
    <p class="text-caption grey--text mt-2">
      {{ countdown }}秒後に自動でスキャナーに戻ります
    </p>
  </div>
</template>

<script>
import {
  ref, onMounted, onBeforeUnmount,
} from '@vue/composition-api'
import {
  mdiCheckCircle, mdiClockAlert, mdiQrcodeScan, mdiCounter,
} from '@mdi/js'
import { format, parseISO } from 'date-fns'

const AUTO_BACK_SECONDS = 5

export default {
  name: 'CheckinResult',
  props: {
    result: { type: Object, default: null },
  },
  setup(props, { emit }) {
    const countdown = ref(AUTO_BACK_SECONDS)
    let timerId = null

    const formatDate = dateStr => {
      try {
        return format(parseISO(dateStr), 'yyyy/MM/dd HH:mm')
      } catch {
        return dateStr
      }
    }

    onMounted(() => {
      timerId = setInterval(() => {
        countdown.value -= 1
        if (countdown.value <= 0) {
          clearInterval(timerId)
          emit('back')
        }
      }, 1000)
    })

    onBeforeUnmount(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      countdown,
      formatDate,
      icons: {
        mdiCheckCircle, mdiClockAlert, mdiQrcodeScan, mdiCounter,
      },
    }
  },
}
</script>
